module.exports = __webpack_public_path__ + "img/asia07.ea665603.png";